import React, { useState, useEffect } from 'react';
import axios, { AxiosRequestHeaders } from 'axios';
import { Link } from 'react-router-dom';
import loaderimage from "../../images/giphy.gif";
import ConfirmationModal from "../shared/ConfirmationModal";
import NewconfirmationModal from "../shared/NewconfirmationModal";
import AllFailureModal from "../shared/AllFailureModal"

interface HrDetail {
  hr_id: number;
  userid: number;
  linkedinid: string;
  company_name: string;
  designation: string;
  isactive: number;
}

const HrList = () => {
  const [hrList, setHrList] = useState<HrDetail[]>([]);
  const [filteredHrList, setFilteredHrList] = useState<HrDetail[]>([]);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [modalMessage, setModalMessage] = useState('');
  const [actionType, setActionType] = useState("");
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const [selectedHrId, setSelectedHrId] = useState<number | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [failureMessage, setFailureMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalHrs, setTotalHrs] = useState(0);
  const [pageSize, setPageSize] = useState(1000);
  useEffect(() => {
    fetchHrList();
  }, []);

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      if (!searchTerm) {
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        setFilteredHrList(hrList.slice(startIndex, endIndex));
      } else {
        const filtered = hrList.filter(
          (hr) =>
            hr.userid.toString().includes(searchTerm) ||
            hr.company_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            hr.designation.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredHrList(filtered);
      }
    }, 300);
    return () => clearTimeout(debounceTimeout);
  }, [searchTerm, hrList, currentPage, pageSize]);

  // Get token from localStorage (use the same key as UsersList)
  const headers: AxiosRequestHeaders = {
    'x-access-token': localStorage.getItem('jwttoken') || '',
  };

  const fetchHrList = async (page = 1) => {
    try {
      setLoader(true);
      setError("");
      const url = `${process.env.REACT_APP_API_URL}hr_details/showallhr_details?page=${page}&limit=${pageSize}`;
      const response = await axios.get(url, { headers }); // Pass headers here
      setHrList(response.data.hrs);
      setTotalHrs(response.data.pagination.totalHrs);
      setTotalPages(response.data.pagination.totalPages);
      setCurrentPage(response.data.pagination.currentPage);
      setFilteredHrList(response.data.hrs);
    } catch (error) {
      setError("Not Found!!!");
      console.error('Error fetching HR list:', error);
    } finally {
      setLoader(false);
    }
  };
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
    const handleAction = async () => {
      if (!selectedUserId) return;
  
      try {
        let url = "";
        if (actionType === "Delete") {
          url = `${process.env.REACT_APP_API_URL}hr_details/deletehr/${selectedUserId}`;
          await axios.put(url, {}, { headers }); // Pass headers here
          setSuccessMessage("HR deleted successfully.");
        } else if (actionType === "Activate") {
          url = `${process.env.REACT_APP_API_URL}users/activateuser/${selectedUserId}`;
          await axios.put(url, {}, { headers }); // Pass headers here
          setSuccessMessage("HR activated successfully.");
        } else if (actionType === "Deactivate") {
          url = `${process.env.REACT_APP_API_URL}users/deactivateuser/${selectedUserId}`;
          await axios.put(url, {}, { headers }); // Pass headers here
          setSuccessMessage("HR deactivated successfully.");
        }
  
        fetchHrList(currentPage);
        setShowSuccessModal(true);
      } catch (error: any) {
        console.error(`Error performing ${actionType} action:`, error);
        setFailureMessage(`Failed to ${actionType} user. ${error.message || ''}`);
        setShowFailureModal(true);
      } finally {
        setShowModal(false);
        setSelectedUserId(null);
      }
    };

  const triggerActionModal = (action: string, userId: number) => {
    setSelectedUserId(userId);
    setActionType(action);
    if (action === "Delete") {
      setModalMessage("Are you sure you want to delete this HR?");
    } else if (action === "Activate") {
      setModalMessage("Are you sure you want to activate this HR?");
    } else if (action === "Deactivate") {
      setModalMessage("Are you sure you want to deactivate this HR?");
    }
    setShowModal(true);
  };
  const startEntry = (currentPage - 1) * pageSize + 1;
  const endEntry = Math.min(currentPage * pageSize, totalHrs);
  return (
    <>
      <div className="">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="text-black fw-bold">HR Management</h2>
          <div className="d-flex gap-2 align-items-center" style={{ width: "510px" }}>
            <span className="fw-bold text-secondary text-nowrap">{totalHrs} results</span>
            <input
              type="text"
              className="form-control"
              placeholder="Search by User ID, Company, or Designation"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Link to="/hradd" className="btn bg-info">+ Add HR</Link>
          </div>
        </div>

        <div className="card shadow-sm border-0 rounded">
          <div className="card-header bg-info border-bottom py-3">
            <h5 className="mb-0 text-white">HR List</h5>
          </div>
          <div className="card-body p-0">
              <div className="table-responsive" style={{ maxHeight: "500px", overflowY: "auto" }}>
                <table className="table table-hover align-middle mb-0">
                  <thead className="bg-light">
                    <tr>
                      <th>Sr No</th>
                      <th>User ID</th>
                      <th>LinkedIn ID</th>
                      <th>Company</th>
                      <th>Designation</th>
                      <th>Status</th>
                      <th className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                      {loader ? (
                        <tr>
                          <td colSpan={10} className="text-center py-2">
                            <img src={loaderimage} alt="Loading..." height="40" />
                          </td>
                        </tr>
                      ) : error ? (
                        <tr>
                          <td colSpan={10} className="text-center text-danger fw-bold py-3">
                            <div className="alert alert-danger text-center m-3" role="alert">
                              Oops! Something went wrong. Please try again later.
                            </div>
                          </td>
                        </tr>
                      ) : filteredHrList.length > 0 ? (
                    filteredHrList.map((hr, index) => (
                      <tr key={index + 1} className="border-bottom">

                        <td>{(currentPage - 1) * pageSize + index + 1}</td>
                        <td>{hr.userid}</td>
                        <td>{hr.linkedinid}</td>
                        <td>{hr.company_name}</td>
                        <td>{hr.designation}</td>
                        <td className="text-center">
                          <span className={`me-2 rounded-circle d-inline-block ${hr.isactive === 1 ? "bg-success" : "bg-danger"}`} 
                              style={{ width: "20px", height: "20px" }}>
                          </span>
                        </td>
                        <td className="text-center">
                          <div className="d-flex justify-content-center gap-2">
                            <button
                            className={`btn btn-sm w-100 ${hr.isactive === 1 ? "btn-outline-danger" : "btn-outline-success"}`}
                            onClick={() => triggerActionModal(hr.isactive === 1 ? "Deactivate" : "Activate", hr.userid)}
                            >
                              {hr.isactive === 1 ? "Deactivate" : "Activate"}
                            </button>
                            <Link to={`/hrupdate/${hr.userid}`} className="btn btn-sm btn-outline-warning">Edit</Link>
                            <button className="btn btn-sm btn-outline-secondary" onClick={() => triggerActionModal("Delete", hr.userid)}>
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                      ))
                  ) : (
                    <tr>
                      <td colSpan={10} className="text-center  text-muted fw-bold">
                      <div className="alert alert-secondary text-center m-3" role="alert">
                      No HR Records Available
                    </div>
                      </td>
                    </tr>
                  )}
                  </tbody>
                </table>
              </div>
              {/* //pagination */}
              <div className="position-sticky bottom-0 bg-white py-2 border-top">
              <div className="d-flex justify-content-between align-items-center">
                <div className="text-muted ps-3">
                  Showing {startEntry}-{endEntry} of {totalHrs} entries
                </div>
                {/* Pagination JSX */}
              <nav>
                 <ul className="pagination mb-0 pe-3">
                 <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                 <button
                 className="page-link"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                >
                Previous
                </button>
                </li>
                {Array.from({ length: totalPages }, (_, index) => (
                <li
                key={index}
                className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}
               >
               <button
               className="page-link"
                onClick={() => handlePageChange(index + 1)}
               >
              {index + 1}
              </button>
           </li>
          ))}
           <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <button
            className="page-link"
             onClick={() => handlePageChange(currentPage + 1)}
             disabled={currentPage === totalPages}
            >
             Next
             </button>
             </li>
             </ul>
             </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModal show={showModal} onHide={() => setShowModal(false)} modalMessage={modalMessage} confirmation={handleAction} operationType={actionType} />
      <NewconfirmationModal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} modalMessage={successMessage} operationType="OK" timeoutDuration={3000} />
      <AllFailureModal show={showFailureModal} onHide={() => setShowFailureModal(false)} modalMessage={failureMessage}  operationType="OK" timeoutDuration={5000}/>
    </>
  );
};

export default HrList;
